export enum BUSINESS_CATEGORY_STEPS {
    CATEGORIES_LIST = 1,
    ADD_EDIT_CATEGORY = 3,
}

export interface AssociatedBusinessType {
    name: string;
    businessCategoryName: string;
    businessTypeId: number;
}

export interface BusinessTypesModal {
    associatedBusinessTypes: AssociatedBusinessType[];
    storeFrontImageReference: string;
    businessClassification: BusinessClassification;
}

export interface LogErrorEventType {
    error: {
        code?: string;
        description?: string;
    };
}

export enum LogEventStatus {
    INITIATED = 'initiated',
    SUCCESS = 'success',
    FAILED = 'failed',
}

export enum BusinessClassification {
    AGENT = 'AGENT',
    MERCHANT = 'MERCHANT',
    UNCLASSIFIED = 'UNCLASSIFIED',
}
